import {
  ApiDrawLienItem,
  ApiSovLienItemNotInDraw,
  SovItem,
} from "../types/inspector.types";

export const formatCurrency = (
  value: string | number | undefined,
  symbol = "$",
): string => {
  if (value === undefined || value === null || value === "") return "";
  const num = Number(String(value).replace(/[^0-9.-]/g, ""));
  if (isNaN(num)) return "";
  return `${symbol}${num.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })}`;
};

const STATUS_LABEL_MAP: Record<string, string> = {
  not_started: "Not Started",
  in_progress: "In Progress",
  completed: "Completed",
  not_billed: "Not billed this draw",
  incurred_as_needed: "~Incurred as needed",
};

export const formatStatus = (status: string): string =>
  STATUS_LABEL_MAP[status] ?? status;

export const mapDrawLienItem = (
  item: ApiDrawLienItem,
  currencySymbol = "$",
): SovItem => {
  const cscEst = Number(item.inspectionData?.cscEstimation);
  const status = isNaN(cscEst) ? 0 : cscEst;
  const thisDraw = formatCurrency(
    item.currentDrawAmount?.amount,
    currencySymbol,
  );
  const pct = item.gcClaimPercentage ? `~${item.gcClaimPercentage}%` : "";

  return {
    id: item.id,
    code: String(item.aiaItem?.itemCode ?? ""),
    desc: item.aiaItem?.itemName ?? "",
    sub: item.subContractor?.companyName ?? "",
    amountBilled: thisDraw ? `${thisDraw} billed` : "",
    sovValue: formatCurrency(item.sovTotal?.amount, currencySymbol),
    prevCertified: formatCurrency(item.prevDrawnAmount?.amount, currencySymbol),
    thisDraw,
    thisDrawNum: item.currentDrawAmount?.amount,
    storedFormatted: item.storedAmount?.amount != null
      ? formatCurrency(item.storedAmount.amount, currencySymbol)
      : undefined,
    storedNum: item.storedAmount?.amount ?? undefined,
    claim: pct,
    defaultStatus: status,
    status,
    customPct: "",
    notes: item.inspectionData?.note?.field ?? "",
    flagged: item.inspectionData?.isFlagged ?? false,
    warning: item.inspectionData?.note?.flag ?? "",
    flagComment: item.inspectionData?.note?.flag ?? "",
    extraComments: Object.entries(item.inspectionData?.note ?? {})
      .filter(([k]) => /^\d+$/.test(k))
      .sort(([a], [b]) => Number(a) - Number(b))
      .map(([, v]) => v as string),
    offsite: item.storedAmount?.amount != null
      ? `Off-site stored: ${formatCurrency(item.storedAmount.amount, currencySymbol)}`
      : undefined,
  };
};

export const mapNotDrawnItem = (
  item: ApiSovLienItemNotInDraw,
): [string, string, string] => [
  String(item.aiaItem?.itemCode ?? ""),
  item.aiaItem?.itemName ?? "",
  formatStatus(item.status ?? ""),
];
